import React from 'react';

import Accordion from '@/components/Shared/Accordion';

import * as S from './styles';

interface IFaq {
  title: string;
  description: string;
}

interface ILinkFAQProps {
  faq: IFaq[];
}

const LinkFAQ: React.FC<ILinkFAQProps> = ({ faq }) => {
  return (
    <S.AccordionContainer>
      <S.FaqTitle>Perguntas frequentes</S.FaqTitle>
      {faq.map(({ title, description }, key) => (
        <Accordion key={key} title={title} description={description} />
      ))}
    </S.AccordionContainer>
  );
};

export default LinkFAQ;
